/** Detect cached HTML/JS as well as a tab left open across a deployment. */
export async function getAppUpdateUrl(currentVersion: string, currentUrl: string): Promise<string | null> {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3000);
  try {
    const response = await fetch('/app-version.json', {
      cache: 'no-store',
      signal: controller.signal,
    });
    if (!response.ok) return null;
    const data = await response.json();
    if (typeof data?.version !== 'string' || !data.version || data.version === currentVersion) return null;

    const url = new URL(currentUrl);
    // A unique document URL bypasses an already cached HTML entry point.
    // Stop after one attempt if the server is still serving inconsistent files.
    if (url.searchParams.get('__app_version') === data.version) return null;
    url.searchParams.set('__app_version', data.version);
    return url.href;
  } catch {
    // Offline, old deployments without the marker and network errors must not block startup.
    return null;
  } finally {
    clearTimeout(timeout);
  }
}
